import React, {useState} from 'react';
import {usePWA} from "../../Pwa";

import {useTheme} from "@mui/material/styles";
import {alpha, useMediaQuery} from "@mui/material";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import {deepOrange} from "@mui/material/colors";

import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import LaptopIcon from '@mui/icons-material/Laptop';


const Instructions = () => {
    const [installed, setInstalled] = useState(false);
    const {isPWAInstallable, installPWA, isStandaloneMode} = usePWA();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {defaultMatches: true});

    const InstallIcon = isDesktop ? LaptopIcon : PhoneAndroidIcon;

    const onInstall = async () => {
        const userOutcome = await installPWA();
        if (userOutcome === 'accepted') {
            setInstalled(true);
        }
    }

    // CASE 1: PWA is ready to be installed we detect "beforeinstallprompt" event
    if (isPWAInstallable) {
        return (
            <>
                <Typography>
                    Per installare l'applicazione di LivignoItaly premi il pulsante installa e segui le istruzioni
                </Typography>
                <Box textAlign="center">
                    <ButtonBase
                        onClick={onInstall}
                        sx={{
                            mt: 2,
                            p: 1,
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                            borderRadius: 1,
                            color: 'primary.main',
                            textTransform: 'uppercase'
                        }}>
                        <InstallIcon sx={{fontSize: 24, mr: 1}}/>
                        <Typography variant="subtitle2">
                            Installa
                        </Typography>
                    </ButtonBase>
                </Box>
            </>
        )
    }

    // CASE 2: PWA has been JUST installed
    // NOTE: we cannot detect if the application was installed before opening this page
    if (installed) {
        return (
            <>
                <Typography>
                    L'app è stata installata, la trovi nell'elenco delle applicazioni del tuo dispositivo.
                </Typography>
            </>
        )
    }

    // CASE 3: User is using the PWA
    if (isStandaloneMode()) {
        return (
            <>
                <Typography>
                    Fantastico, l'applicazione è già installata!
                </Typography>
                <Box textAlign="center" sx={{mt: 2}}>
                    <Button href="/" variant="contained">
                        Continua
                    </Button>
                </Box>
            </>
        )
    }

    // CASE 4: not supported or already installed
    return (
        <>
            <Alert severity="error" sx={{my: 2}}>
                <AlertTitle>Errore</AlertTitle>
                Non è possibile installare l'applicazione poiché si è verificata una delle seguenti anomalie:
                <ul style={{paddingLeft: "30px"}}>
                    <li>Il tuo browser non è supportato, prova ad usare Google Chrome</li>
                    <li>L'applicazione risulta già installata</li>
                </ul>
            </Alert>

        </>
    )
}

const InstructionsIOS = () => {
    const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.indexOf('CriOS') === -1 &&
        navigator.userAgent.indexOf('FxiOS') === -1;

    // CASE 1: Handle Apple device on safari
    if (isSafari) {
        return (
            <>
                <Typography sx={{mb: 2}}>
                    Per installare l'applicazione di LivignoItaly sul tuo dispositivo Apple devi:
                </Typography>

                <Typography color="primary" textAlign="center" sx={{my: 2}}>
                    Premere il tasto
                    <img
                        loading="lazy"
                        width="30"
                        height="30"
                        src={`/img/safari-menu-icon.png`}
                        alt="Safari menu"
                        style={{verticalAlign: "middle", margin: "0 8px"}}
                    />
                    e selezionare la voce "Aggiungi alla schermata Home"
                </Typography>

                <Typography sx={{mt: 2}}>
                    Fatto ciò, troverai l'applicazione installata sul tuo dispositivo!
                </Typography>
            </>
        )
    }

    // CASE 2: Handle Apple device without safari
    return (
        <>
            <Alert severity="warning" sx={{my: 2}}>
                Browser non supportato
            </Alert>
            <Typography>
                Per installare l'applicazione di LivignoItaly sul tuo dispositivo Apple è necessario aprire questa
                pagina utilizzando Safari.
            </Typography>
        </>
    )
}

const Install = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod|macintosh/.test(userAgent);

    return (
        <>
            <Box sx={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: -2,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundImage: "url(/img/login-background.jpg)"
            }}/>
            <Container component="main" maxWidth="xs">
                <Paper sx={{p: 2, my: 2,}}>
                    <Box component="div"
                         sx={{
                             color: deepOrange[500],
                             fontVariant: "small-caps",
                             fontFamily: 'goudyhan',
                             fontSize: "2rem",
                             textAlign: "center",
                             mb: 2
                         }}>
                        LivignoItaly
                    </Box>
                    {
                        isIos ? <InstructionsIOS/> : <Instructions/>
                    }
                    <Divider sx={{my: 2}}/>
                    <Typography color="text.primary">
                        Se hai bisogno di aiuto scrivici: <Link
                        href="mailto:admin@livignoitaly.it">admin@livignoitaly.it</Link>
                    </Typography>
                </Paper>
            </Container>
        </>
    );
};

export default Install;